import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";
import ElitePopup from "ComponentsUI/ElitePopup";

const styles = (theme) => ({
	root: {
		width: "100%",
		minHeight: "400px",
		height: "100%",
		padding: "31px 0 100px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		backgroundColor: theme.palette.colors.white,
		border: "1px solid #d3cee1",
		borderRadius: "10px",
		position: "relative",
		boxSizing: "border-box",
		"&:hover": {
			"& $planHelper": {
				visibility: "visible",
				opacity: 1,
			},
		},
	},
	withoutButtons: {
		paddingBottom: "30px",
		"& $price": {
			marginBottom: "0",
		},
	},
	disabled: {
		"&:after": {
			content: '""',
			position: "absolute",
			left: "-1px",
			top: "-1px",
			right: "-1px",
			bottom: "-1px",
			borderRadius: "10px",
			opacity: ".6",
			zIndex: "5",
			backgroundColor: theme.palette.colors.white,
		},
	},
	dontShowLogo: {
		minHeight: "350px",
		"& $logo": {
			padding: 0,
		},
	},
	planHelper: {
		visibility: "hidden",
		opacity: 0,
		transition: "opacity .3s ease",
	},
	header: {
		"min-height": "135px",
		paddingBottom: "10px",
	},
	elite: {},
	iconList: {
		marginTop: 0,
		marginBottom: 0,
		fontSize: 0,
		lineHeight: 0,
		padding: "10px 20px",
		textAlign: "center",
		boxSizing: "border-box",
		minHeight: 0,
	},
	logo: {
		marginTop: "auto",
		marginBottom: 0,
		fontSize: 0,
		lineHeight: 0,
		boxSizing: "border-box",
		padding: "10px 20px",
		width: "100%",
	},
	price: {
		margin: "auto 0 26px",
		paddingTop: "10px",
		textAlign: "center",
	},
	pricePrepaid: {
		display: "none",
	},
	withSwitcher: {
		paddingTop: 0,
	},
	stub: {
		height: "350px",
		backgroundColor: theme.palette.colors.disabled,
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			minHeight: 0,
			height: "auto",
			padding: "21px 8.33% 50px",
			flexDirection: "row",
			alignItems: "flex-end",
			flexWrap: "wrap",
			justifyContent: "center",
			"&:hover": {
				borderRadius: "10px",
			},
		},
		withSwitcher: {
			padding: "0 0 50px",
		},
		withoutButtons: {
			paddingBottom: "21px",
		},
		planHelper: {
			visibility: "visible",
			opacity: 1,
			width: "100%",
			marginBottom: "25px",
		},
		header: {
			minHeight: 0,
			flexWrap: "wrap",
			width: "100%",
			display: "flex",
			justifyContent: "space-between",
			marginBottom: "25px",
			alignItems: "flex-start",
			paddingBottom: 0,
		},
		logo: {
			marginRight: 0,
			marginBottom: "25px",
			marginTop: 0,
			display: "inline-block",
			verticalAlign: "middle",
			padding: 0,
			width: "100%",
			alignSelf: "center",
		},
		iconList: {
			margin: "0 0 25px",
			padding: 0,
			textAlign: "center",
			boxSizing: "border-box",
			verticalAlign: "middle",
			alignSelf: "center",
			width: "100%",
		},
		price: {
			display: "none",
		},
		pricePrepaid: {
			width: "100%",
			display: "block",
			textAlign: "center",
		},
		stub: {
			height: "200px",
		},
	},
});

const Component = ({
	classes,
	header,
	switcher,
	dody,
	logo,
	price,
	buttons,
	elite,
	showLogo,
	disabled,
	text,
	mobileInfo,
	onClick,
	stub,
	planHelper,
}) => (
	<div
		className={classNames(classes.root, {
			[classes.elite]: elite,
			[classes.stub]: stub,
			[classes.dontShowLogo]: !showLogo,
			[classes.withSwitcher]: !!switcher,
			[classes.withoutButtons]: !buttons,
			[classes.disabled]: disabled,
		})}
		onClick={onClick}
	>
		{switcher && switcher}
		{!!elite && <ElitePopup src={elite.image_24} plans={true} text1={elite.description} />}
		{header && header}
		{mobileInfo && mobileInfo}
		<div className={classes.pricePrepaid}>{price}</div>
		{dody && <div className={classes.iconList}>{dody}</div>}
		{showLogo && <div className={classes.logo}>{logo}</div>}
		<div className={classes.planHelper}>{planHelper}</div>
		<div className={classes.price}>{price}</div>
		{buttons && buttons}
	</div>
);

const PlanALayout = withStyles(styles)(Component);
PlanALayout.displayName = "PlanALayout";

export default PlanALayout;
